module.exports = __webpack_public_path__ + "img/29_65.38aa848d.png";